import {
    deserializeHash,
    serializeHash,
} from "@formant/core/common/serializeHash";
import { IShare } from "@formant/core/model/IShare";

import { shareClient } from "../clients";
import { getViewId } from "../component/Observe/utils/view";
import { authStore } from "../stores";

export async function createDeviceViewShareUrl(share: IShare): Promise<string> {
    const fullfilledShare = await shareClient.create(
        await authStore.token(),
        share,
    );

    const { code } = fullfilledShare;
    const { hash, origin } = window.location;
    const viewId = getViewId();
    const filter = deserializeHash(hash) as Record<string, unknown>;
    // enforce that we will always have the viewId in the hash
    const newHash = serializeHash({ ...filter, viewId });
    return `${origin}/${"shares"}/${code}#${newHash}`;
}
